import { render, staticRenderFns } from "./TheSideMenu.vue?vue&type=template&id=8f3f87ae"
import script from "./TheSideMenu.vue?vue&type=script&lang=ts"
export * from "./TheSideMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports